import _ from "underscore";
import $ from "jquery";

import template from "../templates/modal.jst";

import CustomDataList from "./list";

import CustomData from "../models/custom_data";

import BaseModal from "shared/modal";

import Loading from "shared/loading";
import Flash from "shared/flash";
import Ajax from "shared/ajax";

export default class Modal extends BaseModal {
  get events() {
    return {
      "click .add-custom-data-value": "_onAddCustomDataValue"
    };
  }

  initialize(init) {
    this.model = new CustomData(init);
    $.when(this.model.deferredCustomData, this.model.deferredFields).then(
      this.afterInitializeSuccess.bind(this),
      this.afterInitializeError.bind(this)
    );

    this.model.on("change:valid", () => {
      this._disableSaveIfInvalid();
    });
  }

  render(...args) {
    super.render(...args);
    this.$el.find('.template').html(template({ showFields: this._shouldShowFields() }));
    Loading.show(this.$el.find('.modal-body'));
    this.$el.find('.modal-footer').hide();
    return this;
  }

  remove(...args) {
    Loading.hide();
    super.remove(...args);
  }

  afterInitializeError(response) {
    Loading.hide();
    Flash.showError(Ajax.parseResponse(response).message);
    this.close();
  }

  afterInitializeSuccess() {
    Loading.hide();
    this._setupModalBody();

    if (this._shouldShowFields()) {
      this._setupCustomDataList();
    }

    if (this.model.get("callerMessage")) {
      this.$("[data-section=caller-message]").html(this.model.get("callerMessage"));
    }
  }

  _setupModalBody() {
    let headerText = "";
    const customDataListWrapper = this.$el.find('#customDataListWrapper');
    const saveButton = this.$el.find('.save-custom-data');

    this.$el.find('.modal-footer').show();

    if (this._hasFields()) {
      headerText = this.headerText();
      customDataListWrapper.show();
      saveButton.prop('disabled', false);
    } else {
      headerText = this.noFieldsText();
      customDataListWrapper.hide();
      saveButton.prop('disabled', true);
    }
    this.$el.find('#headerText').html(headerText);
  }

  _setupCustomDataList() {
    if (this._hasFields()) {
      const collection = this.model.buildCollection();

      if (collection.models.length >= this.model.getFieldCount()) {
        this.$('.add-custom-data-value').hide();
      }

      this.listenTo(collection, "add remove", () => {
        if (collection.length >= this.model.getFieldCount()) {
          this.$('.add-custom-data-value').hide();
        } else {
          this.$('.add-custom-data-value').show();
        }
      });

      const list = this._buildList(collection);
      this.$el.find(".custom-data-list").html(list.render().$el);
    }
  }

  _buildList(collection) {
    let list = this.child("list");
    list && list.close();
    list = new CustomDataList({ collection });
    this.child("list", list);
    return list;
  }

  _onAddCustomDataValue() {
    this.model.get('collection').add(this.model.emptyFieldModel());
    this.child("list").$(":input[type=text]:last").focus();
    return false;
  }

  _disableSaveIfInvalid() {
    if (this.model.get('valid')) {
      this.$el.find('.save-custom-data').prop('disabled', false);
    } else {
      this.$el.find('.save-custom-data').prop('disabled', true);
    }
  }

  onSaveButtonClick(parentView) {
    this._hideErrorText();

    this.$el.find('.save-custom-data').prop('disabled', true);
    Loading.show(this.$el.find('.modal-body'));

    this.model.save({}, {
      type: 'PUT',
      wait: true,
      success: (model, response) => {
        this.onSuccessCallBack(response);
      },
      error: (model, response) => {
        this.$el.find('.save-custom-data').prop('disabled', false);
        this.onErrorCallBack(response);
      }
    });

    Loading.hide();
  }

  _validateFieldItems(models) {
    let valid = true;
    _.each(models, item => {
      if (!item.isValid()) {
        valid = false;
      }
    }, this);
    return valid;
  }

  _showErrorText(text) {
    this.$el.find('.modal-validation').html(text).show();
  }

  _hideErrorText() {
    this.$el.find('.modal-validation').html("").hide();
  }

  _hasFields() {
    return this.model.getFieldCount() > 0;
  }

  headerText() {
    return `The following Marketing Data values will be applied to all calls that come in to this ${this.model.get('friendlyModalClassName')}.`;
  }

  noFieldsText() {
    return "You haven't created any Marketing Data Fields yet. Please contact your Customer Success Representative to assist in creating these new Marketing Data Fields.";
  }

  onSuccessCallBack({ owner_custom_data: ownerCustomData }) {
    const customData = (_.keys(ownerCustomData).length > 0);

    this.model.get("row").model.set("custom_data", customData);
    this.model.get("row").render();
    this.model.get("row").$el.find('td').effect('highlight', { color: "#E0EFBD" }, 3000);
    this.close();
  }

  onErrorCallBack(response) {
    this._hideErrorText();
    let message = "";

    if (!_.isUndefined(response.responseJSON) && _.has(response.responseJSON, 'errors') && _.has(response.responseJSON.errors, 'class') && _.has(response.responseJSON.errors, 'invalid_data')) {
      message = `${response.responseJSON.errors.class}: ${_.escape(response.responseJSON.errors.invalid_data)}`;
    } else {
      message = Ajax.defaultErrorMessageWithTimestamp(response);
    }

    this._showErrorText(message);
    return true;
  }

  _shouldShowFields() {
    if (_.isUndefined(this.model.get("showFields"))) {
      return true;
    } else {
      return this.model.get("showFields");
    }
  }
}

_.extend(Modal.prototype, {
  size: 'large',

  title: "Apply Marketing Data",

  body: "<div class='template'><div class='modal-validation'></div>",

  buttons: [
    {
      text: "Cancel",
      className: "btn-secondary",
      close: true
    },
    {
      click() {
        if (this.parent._validateFieldItems(this.parent.child("list").collection.models)) {
          this.parent.onSaveButtonClick.apply(this.parent);
        }
      },
      text: "Save",
      className: 'btn-primary save-custom-data'
    }
  ]
});
